var exports = {
  "k": "x43aef4ae--c6cfa8--container",
  "Q": "x43aef4ae--c6cfa8--text",
};

module.exports = exports;
